import React from 'react'
//mobile app images
import imag1 from '../components/Mobile/ANDROID STUDIO.png'
import imag2 from '../components/Mobile/FLUTTER.png'
import imag3 from '../components/Mobile/KOTLIN.png'
import imag4 from '../components/Mobile/SWIFT.png'

const Technology4 = () => {
  return (
        <div className="technology"  >
          <img className='' data-aos="slide-up" src={imag1} alt="" />
          <img className='' data-aos="slide-down" src={imag2} alt="" />
          <img className='' data-aos="slide-up" src={imag3} alt="" />
          <img className='' data-aos="slide-down" src={imag4} alt="" />
        </div>

  )
}

export default Technology4